<svg width="24" height="24" xmlns="http://www.w3.org/2000/svg">
<path d="M17.1606 5.64572L5.63622 17.1701L6.82947 18.3633L18.3538 6.83896L17.1606 5.64572Z"/>
<path d="M12 21C7.03763 21 3 16.9624 3 12C3 7.03763 7.03763 3 12 3C16.9624 3 21 7.03763 21 12C21 16.9624 16.9624 21 12 21ZM12 4.6875C7.968 4.6875 4.6875 7.968 4.6875 12C4.6875 16.032 7.968 19.3125 12 19.3125C16.032 19.3125 19.3125 16.032 19.3125 12C19.3125 7.968 16.032 4.6875 12 4.6875Z"/>
</svg>
